import { Layout } from '../../../queries/ats/layout/types';
import { classes } from '../../../utils/commonUtils';
import { AtsItemOverwrites } from '../ats-asset/atsAsset.interfaces';
import { AtsImage } from '../AtsImage';
import { AtsItem } from '../AtsItem';
import styles from './AtsBanner.module.scss';

interface AtsBannerProps {
  item: Layout.SectionItem;
  pattern: Layout.Pattern;
  overwrites?: AtsItemOverwrites;
}

export function AtsBanner({ item, pattern, overwrites, ...rest }: AtsBannerProps) {
  return (
    <AtsItem className={styles.container} item={item} pattern={pattern} overwrites={overwrites} {...rest}>
      <AtsImage className={styles.image} item={item} pattern={pattern} width={1600} />
    </AtsItem>
  );
}

export function AtsBannerSkeleton() {
  return (
    <div className={classes(styles.container, styles.skeleton)}>
      <div className={styles.image} />
    </div>
  );
}

AtsBanner.Skeleton = AtsBannerSkeleton;
